import _defineProperty from "/Users/lianzhaocheng/Downloads/workplace/bieyang/web/bybieyang-home/product-search/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/lianzhaocheng/Downloads/workplace/bieyang/web/bybieyang-home/product-search/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useRef } from 'react';
import classNames from 'classnames';
import { useSpring, animated } from '@react-spring/web';
import { withNativeProps } from '../../utils/native-props';
import { usePropsValue } from '../../utils/use-props-value';
import { bound } from '../../utils/bound';
import { useThrottleFn, useIsomorphicLayoutEffect } from 'ahooks';
import { useMutationEffect } from '../../utils/use-mutation-effect';
import { useResizeEffect } from '../../utils/use-resize-effect';
import { mergeProps } from '../../utils/with-default-props';
import { useIsomorphicUpdateLayoutEffect } from '../../utils/use-isomorphic-update-layout-effect';
import { ShouldRender } from '../../utils/should-render';
import { traverseReactNode } from '../../utils/traverse-react-node';
var classPrefix = "adm-tabs";
export var Tab = function Tab() {
  return null;
};
var defaultProps = {
  activeLineMode: 'auto',
  stretch: true
};
export var Tabs = function Tabs(p) {
  var _a;

  var props = mergeProps(defaultProps, p);
  var tabListContainerRef = useRef(null);
  var activeLineRef = useRef(null);
  var keyToIndexRecord = {};
  var firstActiveKey = null;
  var panes = [];
  traverseReactNode(props.children, function (child, index) {
    if (!React.isValidElement(child)) return;
    var key = child.key;
    if (typeof key !== 'string') return;

    if (index === 0) {
      firstActiveKey = key;
    }

    var length = panes.push(child);
    keyToIndexRecord[key] = length - 1;
  });

  var _usePropsValue = usePropsValue({
    value: props.activeKey,
    defaultValue: (_a = props.defaultActiveKey) !== null && _a !== void 0 ? _a : firstActiveKey,
    onChange: function onChange(v) {
      var _a;

      if (v === null) return;
      (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, v);
    }
  }),
      _usePropsValue2 = _slicedToArray(_usePropsValue, 2),
      activeKey = _usePropsValue2[0],
      setActiveKey = _usePropsValue2[1];

  var _useSpring = useSpring(function () {
    return {
      x: 0,
      width: 0,
      config: {
        tension: 300,
        clamp: true
      }
    };
  }),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      _useSpring2$ = _useSpring2[0],
      x = _useSpring2$.x,
      width = _useSpring2$.width,
      api = _useSpring2[1];

  var _useSpring3 = useSpring(function () {
    return {
      scrollLeft: 0,
      config: {
        tension: 300,
        clamp: true
      }
    };
  }),
      _useSpring4 = _slicedToArray(_useSpring3, 2),
      scrollLeft = _useSpring4[0].scrollLeft,
      scrollApi = _useSpring4[1];

  var _useSpring5 = useSpring(function () {
    return {
      leftMaskOpacity: 0,
      rightMaskOpacity: 0,
      config: {
        clamp: true
      }
    };
  }),
      _useSpring6 = _slicedToArray(_useSpring5, 2),
      _useSpring6$ = _useSpring6[0],
      leftMaskOpacity = _useSpring6$.leftMaskOpacity,
      rightMaskOpacity = _useSpring6$.rightMaskOpacity,
      maskApi = _useSpring6[1];

  function animate() {
    var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var container = tabListContainerRef.current;
    if (!container) return;
    var activeIndex = keyToIndexRecord[activeKey];

    if (activeIndex === undefined) {
      api.start({
        x: 0,
        width: 0,
        immediate: true
      });
      return;
    }

    var activeLine = activeLineRef.current;
    if (!activeLine) return;
    var activeTabWrapper = container.children.item(activeIndex + 1);
    var activeTab = activeTabWrapper.children.item(0);
    var activeTabLeft = activeTab.offsetLeft;
    var activeTabWidth = activeTab.offsetWidth;
    var activeTabWrapperLeft = activeTabWrapper.offsetLeft;
    var activeTabWrapperWidth = activeTabWrapper.offsetWidth;
    var containerWidth = container.offsetWidth;
    var containerScrollWidth = container.scrollWidth;
    var containerScrollLeft = container.scrollLeft;
    var activeLineWidth = activeLine.offsetWidth;
    var x = 0;
    var width = 0;

    if (props.activeLineMode === 'auto') {
      x = activeTabLeft;
      width = activeTabWidth;
    } else if (props.activeLineMode === 'full') {
      x = activeTabWrapperLeft;
      width = activeTabWrapperWidth;
    } else {
      x = activeTabLeft + (activeTabWidth - activeLineWidth) / 2;
    }

    api.start({
      x: x,
      width: width,
      immediate: immediate
    });
    var maxScrollDistance = containerScrollWidth - containerWidth;
    if (maxScrollDistance <= 0) return;
    var nextScrollLeft = bound(activeTabLeft - (containerWidth - activeTabWidth) / 2, 0, containerScrollWidth - containerWidth);
    scrollApi.start({
      scrollLeft: nextScrollLeft,
      from: {
        scrollLeft: containerScrollLeft
      },
      immediate: immediate
    });
  }

  useIsomorphicLayoutEffect(function () {
    animate(!x.isAnimating);
  }, []);
  useIsomorphicUpdateLayoutEffect(function () {
    animate();
  }, [activeKey]);
  useResizeEffect(function () {
    animate(!x.isAnimating);
  }, tabListContainerRef);
  useMutationEffect(function () {
    animate(!x.isAnimating);
  }, tabListContainerRef, {
    subtree: true,
    childList: true,
    characterData: true
  });

  var _useThrottleFn = useThrottleFn(function () {
    var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var container = tabListContainerRef.current;
    if (!container) return;
    var scrollLeft = container.scrollLeft;
    var showLeftMask = scrollLeft > 0;
    var showRightMask = scrollLeft + container.offsetWidth < container.scrollWidth;
    maskApi.start({
      leftMaskOpacity: showLeftMask ? 1 : 0,
      rightMaskOpacity: showRightMask ? 1 : 0,
      immediate: immediate
    });
  }, {
    wait: 100,
    trailing: true,
    leading: true
  }),
      updateMask = _useThrottleFn.run;

  useIsomorphicLayoutEffect(function () {
    updateMask(true);
  }, []);
  return withNativeProps(props, React.createElement("div", {
    className: classPrefix
  }, React.createElement("div", {
    className: "".concat(classPrefix, "-header")
  }, React.createElement(animated.div, {
    className: classNames("".concat(classPrefix, "-header-mask"), "".concat(classPrefix, "-header-mask-left")),
    style: {
      opacity: leftMaskOpacity
    }
  }), React.createElement(animated.div, {
    className: classNames("".concat(classPrefix, "-header-mask"), "".concat(classPrefix, "-header-mask-right")),
    style: {
      opacity: rightMaskOpacity
    }
  }), React.createElement(animated.div, {
    className: "".concat(classPrefix, "-tab-list"),
    ref: tabListContainerRef,
    scrollLeft: scrollLeft,
    onScroll: updateMask
  }, React.createElement(animated.div, {
    ref: activeLineRef,
    className: "".concat(classPrefix, "-tab-line"),
    style: {
      width: props.activeLineMode === 'fixed' ? 'var(--fixed-active-line-width, 30px)' : width,
      x: x
    }
  }), panes.map(function (pane) {
    var _classNames2;

    return withNativeProps(pane.props, React.createElement("div", {
      key: pane.key,
      className: classNames("".concat(classPrefix, "-tab-wrapper"), _defineProperty({}, "".concat(classPrefix, "-tab-wrapper-stretch"), props.stretch))
    }, React.createElement("div", {
      onClick: function onClick() {
        var key = pane.key;
        if (pane.props.disabled) return;

        if (key === undefined || key === null) {
          return;
        }

        setActiveKey(key.toString());
      },
      className: classNames("".concat(classPrefix, "-tab"), (_classNames2 = {}, _defineProperty(_classNames2, "".concat(classPrefix, "-tab-active"), pane.key === activeKey), _defineProperty(_classNames2, "".concat(classPrefix, "-tab-disabled"), pane.props.disabled), _classNames2))
    }, pane.props.title)));
  }))), panes.map(function (pane) {
    if (pane.props.children === undefined) {
      return null;
    }

    var active = pane.key === activeKey;
    return React.createElement(ShouldRender, {
      key: pane.key,
      active: active,
      forceRender: pane.props.forceRender,
      destroyOnClose: pane.props.destroyOnClose
    }, React.createElement("div", {
      className: "".concat(classPrefix, "-content"),
      style: {
        display: active ? 'block' : 'none'
      }
    }, pane.props.children));
  })));
};